export const enableBrowserMocks = async () => {
  if (process.env.NODE_ENV === 'development' && SERVER_MODE === 'standalone') {
    const { worker } = await import('./browser');
    worker.start({
      onUnhandledRequest: 'bypass', // to bypass mocking misc requests where we'd want real implementations e.g. i18n
    });
  }
};
